/* eslint-disable import/prefer-default-export */
import t from './DAM.type';
import * as dam from '../../../services/DAM.service';
import { toasterMsg } from '../../../Components/Toaster/Toaster';

const errMsg = 'Failed to fetch data';

export const fetchDamList = (params) => {
  return async (dispatch) => {
    try {
      const response = await dam.fetchDamList(params);
      if (response.code === 200) {
        dispatch({
          type: t.FETCH_DAM_LIST,
          payload: {
            ...params,
            data: response?.data.doc,
            totalCount: response?.data?.totalCount,
          },
        });
      }
      return response;
    } catch (error) {
      toasterMsg(errMsg, 'danger'); // Assuming toasterMsg is a function to display error messages
    }
  };
};

export const fetchDamProductList = () => {
  return async (dispatch) => {
    try {
      const response = await dam.fetchDamProductList();
      dispatch({
        type: t.DAM_ALL_PRODUCT_LIST,
        payload: response?.data,
      });
    } catch (error) {
      toasterMsg(errMsg, 'danger'); // Assuming toasterMsg is a function to display error messages
    }
  };
};

export const fetchDamTag = () => {
  return async (dispatch) => {
    try {
      const response = await dam.fetchDamTagList();
      dispatch({
        type: t.DAM_TAGS_LIST,
        payload: response?.data,
      });
      return response?.data;
    } catch (error) {
      toasterMsg(errMsg, 'danger'); // Assuming toasterMsg is a function to display error messages
    }
  };
};

export const saveDamFiles = (requestPayload, transactionMsg) => {
  return async () => {
    try {
      const res = await dam.saveDamFiles(requestPayload);
      if (res.code === 200) {
        const msg = transactionMsg(`DAM_MAIN_VIEW.BACKEND_SERVICE.${res.message}`);
        toasterMsg(msg, 'success');
      }
      if (res.code === 500) {
        const msg = transactionMsg(`DAM_MAIN_VIEW.BACKEND_SERVICE.${res.data.errMsg}`);
        toasterMsg(msg, 'danger');
      }
    } catch (error) {
      toasterMsg(errMsg, 'danger'); // Assuming toasterMsg is a function to display error messages
    }
  };
};

export const getDamRecordById = (damId) => {
  return async (dispatch) => {
    try {
      const response = await dam.getDamRecordById(damId);
      if (response?.code === 200) {
        dispatch({
          type: t.DAM_EDIT_DATA,
          payload: response?.data,
        });
      }
      return response;
    } catch (error) {
      toasterMsg(errMsg, 'danger'); // Assuming toasterMsg is a function to display error messages
    }
  };
};

export const updateDamFiles = (requestPayload, transactionMsg) => {
  return async () => {
    try {
      const res = await dam.updateDamFiles(requestPayload);
      if (res.code === 200) {
        const msg = transactionMsg(`DAM_MAIN_VIEW.BACKEND_SERVICE.${res.message}`);
        toasterMsg(msg, 'success');
      }
      if (res.code === 500) {
        const msg = transactionMsg(`DAM_MAIN_VIEW.BACKEND_SERVICE.${res?.data?.errMsg}`);
        toasterMsg(msg, 'danger');
      }
    } catch (error) {
      toasterMsg(errMsg, 'danger'); // Assuming toasterMsg is a function to display error messages
    }
  };
};

export const deleteDamFilesByIdAction = (params, transactionMsg) => async () => {
  try {
    const res = await dam.deleteDamFiles(params);
    if (res && res.code === 200) {
      const msg = transactionMsg(`DAM_MAIN_VIEW.BACKEND_SERVICE.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      toasterMsg(res.data.errMsg, 'danger');
    } else {
      toasterMsg(res.message, 'danger');
    }
  } catch (err) {
    toasterMsg(errMsg, 'danger');
  }
};

export const archivedDam = (data, transactionMsg) => async () => {
  try {
    const res = await dam.setArchivedDam(data);
    if (res.code === 200 && res.data) {
      const msg = transactionMsg(`DAM_MAIN_VIEW.BACKEND_SERVICE.${res.message}`);
      toasterMsg(msg, 'success');
      return res.code;
    }
    if (res.code === 400 && res.data) {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
    if (res.code === 500 && res.data) {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
  } catch (err) {
    toasterMsg(errMsg, 'danger');
  }
};

export const clearDamReducer = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: t.DAM_CLEAR_REDUCER,
      });
    } catch (error) {
      toasterMsg(errMsg, 'danger'); // Assuming toasterMsg is a function to display error messages
    }
  };
};

export const duplicateDamFile = (obj, damId, transactionMsg) => async () => {
  try {
    const res = await dam.duplicateDamFile(obj, damId);
    if (res && res.code === 200 && res.data) {
      const msg = transactionMsg(`DAM_MAIN_VIEW.BACKEND_SERVICE.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(`DAM_MAIN_VIEW.BACKEND_SERVICE.${res.data.errMsg}`), 'danger');
    } else {
      toasterMsg(transactionMsg(res.message), 'danger');
    }
  } catch (err) {
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchDamAcrhivedFiles = (params) => {
  return async (dispatch) => {
    try {
      const response = await dam.fetchDamAcrhivedFiles(params);
      if (response.code === 200) {
        dispatch({
          type: t.SET_ARCHIVED_FILES_FOLDERS,
          payload: {
            ...params,
            data: response?.data.doc,
            totalCount: response?.data?.totalCount,
          },
        });
      }
      return response;
    } catch (error) {
      toasterMsg(errMsg, 'danger'); // Assuming toasterMsg is a function to display error messages
    }
  };
};

export const updateFileInFolderCollection = (obj, transactionMsg) => async () => {
  try {
    const res = await dam.updateFileInFolderCollection(obj);
    if (res && res.code === 200 && res.data) {
      const msg = transactionMsg(`DAM_FOLDER_VIEW.BACKEND_SERVICE.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    } else {
      toasterMsg(transactionMsg(res.message), 'danger');
    }
    return res;
  } catch (err) {
    toasterMsg(errMsg, 'danger');
  }
};

export const filterSortData = (obj) => async (dispatch) => {
  try {
    await dispatch({
      type: t.DAM_SET_FILTER_SORT_DATA,
      payload: obj,
    });
  } catch (error) {
    toasterMsg(errMsg, 'danger');
  }
};

export const fetchDamDeletedFiles = (params) => {
  return async (dispatch) => {
    try {
      const response = await dam.fetchDamDeletedFiles(params);
      if (response.code === 200) {
        dispatch({
          type: t.SET_DELETED_FILES,
          payload: {
            ...params,
            data: response?.data.doc,
            totalCount: response?.data?.totalCount,
          },
        });
      }
      return response;
    } catch (error) {
      toasterMsg(errMsg, 'danger'); // Assuming toasterMsg is a function to display error messages
    }
  };
};

export const updateProductDamRecord = (requestPayload, transactionMsg) => {
  return async () => {
    try {
      const res = await dam.updateProductDamRecord(requestPayload);
      if (res.code === 200) {
        const msg = transactionMsg(`DAM_MAIN_VIEW.BACKEND_SERVICE.${res.message}`);
        toasterMsg(msg, 'success');
      }
      if (res.code === 500) {
        const msg = transactionMsg(`DAM_MAIN_VIEW.BACKEND_SERVICE.${res?.data?.errMsg}`);
        toasterMsg(msg, 'danger');
      }
    } catch (error) {
      toasterMsg(errMsg, 'danger'); // Assuming toasterMsg is a function to display error messages
    }
  };
};

export const checkDamNameExist = (requestPayload) => {
  return async () => {
    try {
      const res = await dam.checkDamNameExist(requestPayload);
      return res.data;
    } catch (error) {
      toasterMsg(errMsg, 'danger'); // Assuming toasterMsg is a function to display error messages
    }
  };
};

export const fetchAllDAmFolders = () => {
  return async (dispatch) => {
    try {
      const response = await dam.fetchAllDAmFolders();
      dispatch({
        type: t.DAM_ALL_FOLDER_LIST,
        payload: response?.data,
      });
      return response?.data;
    } catch (error) {
      toasterMsg(errMsg, 'danger'); // Assuming toasterMsg is a function to display error messages
    }
  };
};
